// This function allows for checking whether the CSS was disabled on the browser, by using
// a bootstrap "position-absolute" class on a temporary test element, which would display
// as "static" if CSS is disabled.
//
export const checkCssIsDisabled = () => {
  const testElement = document.createElement("div");
  testElement.className = "position-absolute";
  document.getElementsByTagName("body")[0].appendChild(testElement);

  let currentStyle;

  if (testElement.currentStyle) {
    currentStyle = testElement.currentStyle["position"];
  } else if (window.getComputedStyle) {
    currentStyle = document.defaultView
      .getComputedStyle(testElement, null)
      .getPropertyValue("position");
  }

  const isCssDisabled = currentStyle == "static";

  document.getElementsByTagName("body")[0].removeChild(testElement);

  return isCssDisabled;
};
